
















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ajax from "@/lib/ajax";

class PagegroupBuyRecordRequest extends PageRequest {
  groupBuyId: number = null;
  sorting: string = "Id ASC";
}

@Component({
  components: {},
})
export default class groupBuyRecords extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: null }) id: number | null;

  pagerequest: PagegroupBuyRecordRequest = new PagegroupBuyRecordRequest();
  groupBuyId: number = null;
  get list() {
    return this.$store.state.joinGroupBuyRecord.list;
  }

  get loading() {
    return this.$store.state.joinGroupBuyRecord.loading;
  }
  pageChange(page: number) {
    this.$store.commit("joinGroupBuyRecord/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("joinGroupBuyRecord/setPageSize", pagesize);
    this.getpage();
  }
  get orderStatesDic() {
    return this.$store.state.common.orderStatesDic;
  }
  // search() {
  //   this.$store.commit("joinGroupBuyRecord/setCurrentPage", 1);
  //   this.getpage();
  // }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "joinGroupBuyRecord/getAll",
      data: this.pagerequest,
    });
  }
  save() {
    this.$emit("input", false);
  }
  async deleteRecordId(id) {
    console.log(id, "id");
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: "确定要该参团记录吗",
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        await ajax
          .delete("/api/services/app/JoinGroupBuyRecord/Delete?id=" + id)
          .then(() => {
            this.$Message.success({
              content: "删除成功",
            });
          });
        await this.getpage();
      },
    });
  }
  get pageSize() {
    return this.$store.state.joinGroupBuyRecord.pageSize;
  }
  get totalCount() {
    return this.$store.state.joinGroupBuyRecord.totalCount;
  }
  get currentPage() {
    return this.$store.state.joinGroupBuyRecord.currentPage;
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      if (this.id) {
        this.pagerequest.groupBuyId = this.id;
      }
      this.$store.commit("joinGroupBuyRecord/setCurrentPage", 1);
      await this.$store.dispatch({
        type: "joinGroupBuyRecord/getAll",
        data: this.pagerequest,
      });
    }
  }
  columns = [
    {
      title: "参团人姓名",
      key: "name",
    },
    {
      title: "参团人手机号",
      key: "phoneNumber",
    },
    {
      title: "性别",
      key: "sex",
      render: (h: any, params: any) => {
        return h("span", params.row.sex == 1 ? "男" : "女");
      },
    },
    {
      title: "是否团长",
      render: (h: any, params: any) => {
        return h(
          "span",
          !params.row.isFollow && params.row.isHead ? "是" : "否"
        );
      },
    },
    {
      title: "拼团状态",
      render: (h: any, params: any) => {
        return h("span", this.orderStatesDic[params.row.orderState]);
      },
    },
    {
      title: "杆数",
      render: (h: any, params: any) => {
        return h("span", params.row.stemNumber);
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.creationTime).toLocaleString());
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 80,
      align: "center",
      slot: "action",
    },
  ];
}
